export default __webpack_public_path__ + "static/no-21044839ace7ca5ecbb523f50b857a6c.svg";